import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'disputeIcon', standalone: true, pure: true })
export class DisputeIconPipe implements PipeTransform {
  transform(type: string): string | undefined {
    switch (type) {
      case 'dispute.customer_dispute_initiated':
      case 'dispute.cleaning.customer.opened':
        return 'assets/img/yellow-pending.svg';
      case 'dispute.customer_dispute_counter_answer':
      case 'dispute.cleaning.customer.counter_proposal':
        return 'assets/img/yellow-alert.svg';
      case 'dispute.customer_dispute_won':
      case 'dispute.customer_dispute_lost':
      case 'dispute.cleaning.customer.won':
      case 'dispute.cleaning.customer.lost':
        return 'assets/img/checkmark.svg';
      default:
        if (type?.startsWith('dispute.')) {
          return 'assets/img/yellow-alert.svg';
        }
        return undefined;
    }
  }
}
